import React, { useState } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { IconButton, Menu, MenuItem, Stack, TableCell, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface Props {
  files: {
    id: number;
    name: string;
    file_url: string;
  }[];
  setPdf: (pdf: { id: number; file_url: string; name: string } | null) => void;
}

export const FilesCell: React.FC<Props> = ({ files, setPdf }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  return (
    <TableCell sx={{ borderBottom: "1px solid #dbe8f5" }}>
      <Stack direction="row" gap="5px" alignItems="center">
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
          <DescriptionOutlinedIcon sx={{ color: "#26A6AE" }} />
        </IconButton>

        <Typography color="#26A6AE">+{files.length}</Typography>
      </Stack>
      <Menu sx={{ p: "10px" }} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {files.map((file: { id: number; name: string; file_url: string }) => (
          <MenuItem key={file.id} onClick={() => setPdf(file)}>
            <Stack direction="row" gap="10px">
              <DescriptionOutlinedIcon />
              <MaterialTooltip isShow title={file.name}>
                <Typography
                  sx={{ maxWidth: "150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {file.name}
                </Typography>
              </MaterialTooltip>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </TableCell>
  );
};
